import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Row,
  Col,
  Card,
  Badge,
  Dropdown,
  ProgressBar,
  Button,
  Alert,
  Modal,
  Form
} from "react-bootstrap";
import swal from "sweetalert";
import axiosInstance from '../../services/AxiosInstance';
import { Link } from 'react-router-dom';
import '../tasks/tasklist.css';
import '../../css/SearchFilterPanel.css';
import './userlist.css';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import CommonTable from '../components/CommonTable/CommonTable';
import { canAccessUsers, getCurrentUserRole, getRoleBasedUserFilters, isCorporateAdmin } from '../../utils/roleAccess';
const UserList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [adminShow, setAdminShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [resetModalShow, setResetModalShow] = useState(false);
  const [resetUserId, setResetUserId] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const [searchText, setSearchText] = useState('')
  const [orgUsers, setOrgUsers] = useState([])
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [filterBranch, setFilterBranch] = useState('');
  const [filterDepartment, setFilterDepartment] = useState('');
  const [filterSubDepartment, setFilterSubDepartment] = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [subDepartmentList, setSubDepartmentList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [searchDropDown, setSearchDropDown] = useState(false);
  const filterRef = useRef(null);
  const [tempFilters, setTempFilters] = useState({
    branch: '',
    department: '',
    sub_department: '',
    role: '',
  });
  const [panelDepartmentList, setPanelDepartmentList] = useState([]);
  const [panelSubDepartmentList, setPanelSubDepartmentList] = useState([]);

  const notifyTopRight = (data) => {
    toast.success(`✔️ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyError = (data) => {

    toast.error(`❌ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  useEffect(() => {
    const userRole = getCurrentUserRole();
    setAdminShow(canAccessUsers(userRole));
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      const corporateId = userData?.corporateId || userData?.id;
      const roleFilters = await getRoleBasedUserFilters(axiosInstance);
      const branchId = filterBranch || roleFilters.branch;
      const deptId = filterDepartment || roleFilters.department;

      const [branchesRes, departmentsRes, subDeptsRes, rolesRes] = await Promise.all([
        axiosInstance.get(`/settings/branches?corporate_id=${corporateId}`),
        axiosInstance.get(`/settings/departments?corporate_id=${corporateId}${branchId ? `&branch_id=${branchId}` : ''}`),
        axiosInstance.get(`/settings/subDepartments?corporate_id=${corporateId}${deptId ? `&department_id=${deptId}` : ''}${branchId ? `&branch_id=${branchId}` : ''}`),
        axiosInstance.get('/corporaterolepermission/corporateuserrolelist'),
      ]);

      let branches = branchesRes.data?.data || branchesRes.data || [];
      let departments = departmentsRes.data?.data || departmentsRes.data || [];
      const subDepts = subDeptsRes.data?.data || subDeptsRes.data || [];
      const roles = rolesRes.data?.data || rolesRes.data || [];

      if (roleFilters.branch && !filterBranch) {
        branches = branches.filter((b) => String(b.id) === String(roleFilters.branch));
      }
      if (roleFilters.department && !filterDepartment) {
        departments = departments.filter((d) => String(d.id) === String(roleFilters.department));
      }
      if (roleFilters.sub_department && !filterSubDepartment) {
        setSubDepartmentList(subDepts.filter((sd) => String(sd.id) === String(roleFilters.sub_department)));
      } else {
        setSubDepartmentList(subDepts);
      }

      setBranchList(branches);
      setDepartmentList(departments);
      setRoleList(roles.filter((r) => r.name !== 'super_admin'));
    } catch (err) {
      console.error('Error fetching filter options:', err);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, [filterBranch, filterDepartment]);

  const fetchPanelFilterOptions = async (branchId, departmentId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      const corporateId = userData?.corporateId || userData?.id;
      const roleFilters = await getRoleBasedUserFilters(axiosInstance);
      const effectiveBranchId = branchId || roleFilters.branch;
      const effectiveDeptId = departmentId || roleFilters.department;

      const [departmentsRes, subDeptsRes] = await Promise.all([
        axiosInstance.get(`/settings/departments?corporate_id=${corporateId}${effectiveBranchId ? `&branch_id=${effectiveBranchId}` : ''}`),
        axiosInstance.get(`/settings/subDepartments?corporate_id=${corporateId}${effectiveDeptId ? `&department_id=${effectiveDeptId}` : ''}${effectiveBranchId ? `&branch_id=${effectiveBranchId}` : ''}`),
      ]);

      let departments = departmentsRes.data?.data || departmentsRes.data || [];
      let subDepts = subDeptsRes.data?.data || subDeptsRes.data || [];

      if (roleFilters.department && !departmentId && !branchId) {
        departments = departments.filter((d) => String(d.id) === String(roleFilters.department));
      }
      if (roleFilters.sub_department && !departmentId) {
        subDepts = subDepts.filter((sd) => String(sd.id) === String(roleFilters.sub_department));
      }

      setPanelDepartmentList(departments);
      setPanelSubDepartmentList(subDepts);
    } catch (err) {
      console.error('Error fetching panel filter options:', err);
    }
  };

  useEffect(() => {
    if (searchDropDown) {
      setTempFilters({
        branch: filterBranch,
        department: filterDepartment,
        sub_department: filterSubDepartment,
        role: filterRole,
      });
    }
  }, [searchDropDown]);

  useEffect(() => {
    if (searchDropDown) {
      fetchPanelFilterOptions(tempFilters.branch, tempFilters.department);
    }
  }, [searchDropDown, tempFilters.branch, tempFilters.department]);

  const handleClickOutside = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setSearchDropDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleTempFilterChange = (field, value) => {
    if (field === 'branch') {
      setTempFilters((prev) => ({
        ...prev,
        branch: value,
        department: '',
        sub_department: '',
      }));
    } else if (field === 'department') {
      setTempFilters((prev) => ({
        ...prev,
        department: value,
        sub_department: '',
      }));
    } else {
      setTempFilters((prev) => ({ ...prev, [field]: value }));
    }
  };

  const applyFilters = () => {
    setFilterBranch(tempFilters.branch);
    setFilterDepartment(tempFilters.department);
    setFilterSubDepartment(tempFilters.sub_department);
    setFilterRole(tempFilters.role);
    setSearchDropDown(false);
  };

  const clearFilters = () => {
    setTempFilters({
      branch: '',
      department: '',
      sub_department: '',
      role: '',
    });
    setFilterBranch('');
    setFilterDepartment('');
    setFilterSubDepartment('');
    setFilterRole('');
    setSearchDropDown(false);
  };

  const handleSearch = async (pageNum = 1, append = false) => {
    try {
      if (pageNum === 1) setLoading(true);
      else setLoadingMore(true);

      const params = new URLSearchParams({
        page: pageNum,
        limit: 10,
      });

      const userData = JSON.parse(localStorage.getItem("user"))
      params.append('corporateId', parseInt(userData.corporateId))

      if (searchText) params.append('search', searchText);

      params.append('CorporateId', parseInt(userData.corporateId));

      const roleFilters = await getRoleBasedUserFilters(axiosInstance);
      if (filterBranch) {
        params.append('branch', filterBranch);
      } else if (roleFilters.branch) {
        params.append('branch', roleFilters.branch);
      }
      if (filterDepartment) {
        params.append('department', filterDepartment);
      } else if (roleFilters.department) {
        params.append('department', roleFilters.department);
      }
      if (filterSubDepartment) {
        params.append('sub_department', filterSubDepartment);
      } else if (roleFilters.sub_department) {
        params.append('sub_department', roleFilters.sub_department);
      }
      if (filterRole) {
        params.append('role', filterRole);
      }

      const res = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const result = res.data.users;

      if (append) {
        setUsers(prev => [...prev, ...result]);
      } else {
        setUsers(result);
      }

      setHasMore(result.length === 10);
      setPage(pageNum);
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    handleSearch()
  }, [searchText, filterBranch, filterDepartment, filterSubDepartment, filterRole])
  useEffect(() => {
    const handleWindowScroll = () => {
      const threshold = 5;
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - threshold &&
        hasMore && !loadingMore && !loading
      ) {
        handleSearch(page + 1, true);
      }
    };
    window.addEventListener('scroll', handleWindowScroll);
    return () => {
      window.removeEventListener('scroll', handleWindowScroll);
    };
  }, [hasMore, loadingMore, loading, page]);
  const handleEdit = (corporateUserId) => {
    navigate('/settings/edituser', {
      state: { corporateUserId },
    });
  };

  const handleDeleteWithConfirmation = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this user!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        let result = await handleDelete(id);
        if (result === 'deleted') {
          swal("Deleted successfully!", {
            icon: "success",
          })
        }
      } else {
        swal("User is safe!");
      }
    });
  };

  const handleDelete = async (userId) => {
    try {
      const response = await axiosInstance.delete(`/auth/corporateuser/delete`, {
        data: { corporateUserId: userId },
      })
      if (response) {
        setUsers(users.filter(user => user.id !== userId));
        console.log(`Deleted user with ID: ${userId}`);
        return 'deleted';
      } else {
        notifyError(response.data.message)
      }
    }
    catch (error) {
      notifyError(error)
      return 'error';
    }
  };

  const handleAdd = () => {
    navigate('/settings/adduser');
  };

  const handleResetPassword = (corporateUserId) => {
    setResetUserId(corporateUserId);
    setNewPassword('');
    setRepeatPassword('');
    setPasswordError('');
    setResetModalShow(true);
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== repeatPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    setPasswordError('');
    setResetLoading(true);
    try {
      const response = await axiosInstance.post('/auth/forgotpassword/resetpassworduser', {
        userId: resetUserId,
        newPassword: newPassword,
      });
      if (response.data && response.data.message === 'Success: Password reset') {
        notifyTopRight('Password reset successfully');
        setResetModalShow(false);
      } else {
        notifyError(response.data.message || 'Failed to reset password');
      }
    } catch (error) {
      notifyError(error?.response?.data?.message || 'Error resetting password');
    } finally {
      setResetLoading(false);
    }
  };

  const filteredUsers = users.filter(user =>
    user.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (user.phone && user.phone.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (user.department_name && user.department_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (user.branch_name && user.branch_name.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Define columns for CommonTable
  const columns = [
    {
      key: 'index',
      header: '#',
      accessor: (row, index) => index + 1,
      cellClassName: '',
    },
    {
      key: 'name',
      header: 'Name',
      accessor: 'full_name',
    },
    {
      key: 'email',
      header: 'Email',
      accessor: 'email',
    },
    {
      key: 'phone',
      header: 'Phone Number',
      accessor: (row) => row.phone || 'N/A',
    },
    {
      key: 'department',
      header: 'Department',
      accessor: (row) => row.department_name || 'N/A',
    },
    {
      key: 'sub_department',
      header: 'Sub Department',
      accessor: (row) => row.sub_department_name || 'N/A',
    },
    {
      key: 'branch',
      header: 'Branch',
      accessor: (row) => row.branch_name || 'N/A',
    },
    {
      key: 'role',
      header: 'Role',
      accessor: (row) => (row.role_name || '').replace(/_/g, ' ') || 'N/A',
    },
  ];

  // Define actions for CommonTable
  const getActions = (row, rowIndex) => {
    if (!adminShow) return [];
    
    const actions = [
      {
        label: 'Reset Password',
        icon: 'fas fa-key',
        onClick: () => handleResetPassword(row.id),
      },
      {
        label: 'Edit',
        icon: 'fas fa-edit',
        onClick: () => handleEdit(row.id),
      },
    ];

    if (isCorporateAdmin(getCurrentUserRole())) {
      actions.push({
        label: 'Access Control',
        icon: 'fas fa-shield-alt',
        onClick: () => navigate('/settings/accessControl', { state: { userId: row.id, fromUserList: true } }),
      });
    }

    if (row.user_type !== 'corporate') {
      actions.push({
        label: 'Delete',
        icon: 'fas fa-trash',
        className: 'text-danger',
        onClick: () => handleDeleteWithConfirmation(row.id),
      });
    }

    return actions;
  };
  return (
    <Row style={{marginBottom: "0px !important"}}>
      <ToastContainer />
      <Col lg={12}>
        <Card className="user-list-card">
          <Card.Header style={{ display: 'block' }}>
            
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="search-input-group">
                  <i className="fas fa-search search-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search users..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center gap-2">
                  {users.length >= 20 && (
                  <button
                    className="btn"
                    onClick={() => setSearchDropDown(true)}
                    style={{
                      borderRadius: '8px',
                      padding: '0.5rem 1rem',
                      border: 'none',
                      color: '#C42126',
                      background: 'transparent',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.background = '#f8f9fa';
                      e.target.style.color = '#C42126';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.background = 'transparent';
                      e.target.style.color = '#C42126';
                    }}
                  >
                    <i className="fas fa-filter me-2"></i>
                    Filters
                  </button>
                  )}
                  {adminShow && (
                    <Link to='/settings/adduser' className="new-user-btn">
                      <i className="fas fa-plus me-2"></i>
                      Add User
                    </Link>
                  )}
                </div>
            </div>

            {searchDropDown && users.length >= 20 && (
              <div className="filter-wrapper" ref={filterRef} style={{marginTop: '10px'}}>
                <div className="content">
                  <div className="main-filters">
                    <div className="filter-form">
                      <div className="filter-row">
                        <div className="filter-group">
                          <label>Filter by Branch</label>
                          <select
                            value={tempFilters.branch}
                            onChange={(e) => handleTempFilterChange('branch', e.target.value)}
                          >
                            <option value="">All Branches</option>
                            {branchList.map((b) => (
                              <option key={b.id} value={b.id}>{b.name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="filter-group">
                          <label>Filter by Department</label>
                          <select
                            value={tempFilters.department}
                            onChange={(e) => handleTempFilterChange('department', e.target.value)}
                          >
                            <option value="">All Departments</option>
                            {panelDepartmentList.map((d) => (
                              <option key={d.id} value={d.id}>{d.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="filter-row">
                        <div className="filter-group">
                          <label>Filter by Sub Department</label>
                          <select
                            value={tempFilters.sub_department}
                            onChange={(e) => handleTempFilterChange('sub_department', e.target.value)}
                          >
                            <option value="">All Sub Departments</option>
                            {panelSubDepartmentList.map((sd) => (
                              <option key={sd.id} value={sd.id}>{sd.name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="filter-group">
                          <label>Filter by Role</label>
                          <select
                            value={tempFilters.role}
                            onChange={(e) => handleTempFilterChange('role', e.target.value)}
                          >
                            <option value="">All Roles</option>
                            {roleList.map((r) => (
                              <option key={r.id} value={r.id}>{r.name?.replace(/_/g, ' ')}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="filter-actions">
                      <button className="search-btn" onClick={applyFilters}>
                        <i className="fas fa-search me-2"></i>
                        Apply Filters
                      </button>
                      <button className="reset-btn" onClick={clearFilters}>
                        <i className="fas fa-times me-2"></i>
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Card.Header>
          <Card.Body style={{ minHeight: '400px', overflow: 'visible', padding: '1.5rem' }}>
            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
              </div>
            ) : (
              <div className="row">
                <CommonTable
                  columns={columns}
                  data={filteredUsers}
                  actions={adminShow ? getActions : []}
                  emptyMessage="No users found"
                  emptyStateIcon="fas fa-users"
                  getRowId={(row) => row.id}
                  maxHeight="70vh"
                  minHeight="400px"
                />
              </div>
            )}
            {loadingMore && (
              <div className="loading-container">
                <div className="loading-spinner"></div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
      <Modal show={resetModalShow} onHide={() => setResetModalShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleResetPasswordSubmit}>
          <Modal.Body>
            <Form.Group controlId="formNewPassword">
              <Form.Label>New Password</Form.Label>
              <div className="position-relative password-input-wrapper">
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  <i className={`fas ${showNewPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </Form.Group>
            <Form.Group controlId="formRepeatPassword" className="mt-3">
              <Form.Label>Repeat Password</Form.Label>
              <div className="position-relative password-input-wrapper">
                <Form.Control
                  type={showRepeatPassword ? "text" : "password"}
                  value={repeatPassword}
                  onChange={e => setRepeatPassword(e.target.value)}
                  placeholder="Repeat new password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                >
                  <i className={`fas ${showRepeatPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </Form.Group>
            {passwordError && (
              <div style={{ color: 'red', marginTop: '10px' }}>{passwordError}</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setResetModalShow(false)} disabled={resetLoading}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={resetLoading || !newPassword || !repeatPassword}>
              {resetLoading ? 'Resetting...' : 'Reset Password'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <InternalFooter />
    </Row>
  )
};



export default UserList;

